document.addEventListener("DOMContentLoaded", function () {
  const completionModal = document.getElementById("completionModal");

  completionModal.addEventListener("click", async () => {
    const currentVariantInput = document.getElementById("currentVariant");
    const currentVariantId = currentVariantInput.value;
    const quantityInput = document.querySelector(".quantity__input");
    const quantity = quantityInput.value;
    const properties = {};
    const optionListItems = document.querySelectorAll(".option__modal__option__list");
    const requiredOptionItems = Array.from(document.querySelectorAll(".required-item"));
    const requiredCheckArray = [];

    const addItemFrontError = "failed-to-add-item-in-front";

    const isValidChecker = (isValid) => {
      requiredCheckArray.push(isValid);
    };

    // 必須項目を取得して一つ一つ回して必須項目を判定。
    requiredOptionItems.forEach((requiredItem) => {
      const requiredSelectors = Array.from(requiredItem.querySelectorAll("select", "input", "textarea"));
      // 何も入ってなかったときはスルー
      if (requiredSelectors.length === 0) {
        return;
      }
      // すべての要素がインプット要素だった場合
      if (requiredOptionItems.every((selector) => selector.tagName === "INPUT")) {
        // 中身がラジオボタンの場合は、一つでもチェックされているかを確認する。
        if (
          requiredSelectors.every((selector) => selector.type === "radio") ||
          requiredSelectors.every((selector) => selector.type === "checkbox")
        ) {
          isValidChecker(requiredSelectors.some((selector) => selector.checked));
        }
        // 中身がテキストボックスのみの場合は、一つでも入力されているかを確認する。
        if (requiredSelectors.every((selector) => selector.type === "text")) {
          isValidChecker(requiredSelectors.some((selector) => selector.value));
        }
      }
      // セレクトボックスのみのときはバリューが選択されているか判定
      if (requiredSelectors.every((selector) => selector.tagName === "SELECT")) {
        isValidChecker(requiredSelectors.some((selector) => selector.value));
      }
      // テキストエリアのみのときは値が入力されているか判定
      if (requiredSelectors.every((selector) => selector.tagName === "TEXTAREA")) {
        isValidChecker(requiredSelectors.some((selector) => selector.value));
      }
    });

    // オプションの項目を取得して一つ一つ回してpropertiesオブジェクトを作る。
    optionListItems.forEach((item) => {
      const name = item.querySelector(".option__modal__title").innerHTML;
      const optionSelectors = item.querySelectorAll("select, input, textarea");
      if (optionSelectors.length === 0) return;
      optionSelectors.forEach((selector) => {
        if (selector.name === "dummy") return;

        if (selector.tagName === "SELECT") {
          properties[name] = selector.value;
        }
        if (selector.tagName === "TEXTAREA") {
          properties[name] = selector.value;
        }
        if (selector.tagName === "INPUT") {
          switch (selector.type) {
            case "radio":
              if (selector.checked) properties[name] = selector.value;
              break;
            case "checkbox":
              if (selector.checked && selector.value !== "") {
                if (!properties[name]) {
                  properties[name] = selector.value;
                } else {
                  properties[name] += `, ${selector.value}`;
                }
              }
              break;
            case "text":
              properties[name] = selector.value;
              break;
            default:
              break;
          }
        }
      });
    });

    if (requiredCheckArray.some((check) => check === false)) {
      alert("必須項目を入力してください。");
      return;
    } else {
      try {
        const items = [
          {
            id: Number(currentVariantId),
            quantity: Number(quantity),
            properties,
          },
        ];
        const resFromPostCart = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items,
          }),
        });
        const resFromGetCart = await fetch("/cart.js");

        if (!resFromPostCart.ok) throw new Error(addItemFrontError);

        const addedItem = await resFromPostCart.json();
        const allItems = await resFromGetCart.json();
        const orderKey = addedItem.items[0].key || null;
        const cartToken = allItems.token || null;
        const { permanentDomain, customerId } = COMMON_SHOPIFY_PROPERTY;
        const data = [
          {
            data: [
              {
                ...items[0],
                cartToken,
              },
            ],
            keyValue: "options",
          },
        ];

        let customerIdForLog = "";

        if (customerId) customerIdForLog = String(customerId);

        await saveLogNoteAttribute(customerIdForLog, data, orderKey, permanentDomain);

        modalArea.classList.remove("is-show");
        window.location.href = "/cart";
      } catch (err) {
        alert("カートに商品を追加できませんでした。注文個数が購入可能数を超えています。");
      }
    }
  });
});
